import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const SlidersIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path fillRule="evenodd" clipRule="evenodd" d="M7.875 5.25C6.425 5.25 5.25 6.426 5.25 7.875C5.25 9.324 6.425 10.5 7.875 10.5C9.325 10.5 10.5 9.324 10.5 7.875C10.5 6.426 9.325 5.25 7.875 5.25Z" stroke="currentColor" strokeWidth="1.5" /><path d="M5.25 7.875H2.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M21.75 7.875H10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path fillRule="evenodd" clipRule="evenodd" d="M16.125 13.5C14.675 13.5 13.5 14.676 13.5 16.125C13.5 17.574 14.675 18.75 16.125 18.75C17.575 18.75 18.75 17.574 18.75 16.125C18.75 14.676 17.575 13.5 16.125 13.5Z" stroke="currentColor" strokeWidth="1.5" /><path d="M21.75 16.125H18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M13.5 16.125H2.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SlidersIcon;